import React, { useState, useRef, useEffect } from "react";
import { DateRange } from "react-date-range";
import { fr } from "date-fns/locale";
import { format } from "date-fns";
import { X } from "lucide-react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const DateRangeInput = ({
    onChange,
    title = null,
    title2 = null,
    initialStartDate = null,
    initialEndDate = null
}) => {
    const [dateRange, setDateRange] = useState([
        { startDate: initialStartDate, endDate: initialEndDate, key: "selection" },
    ]);
    const [showCalendar, setShowCalendar] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 840);
    const wrapperRef = useRef(null);

    // Met à jour dateRange si les props changent
    useEffect(() => {
        setDateRange([{ startDate: initialStartDate, endDate: initialEndDate, key: "selection" }]);
    }, [initialStartDate, initialEndDate]);

    // Détecte le mobile
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 840);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSelect = (ranges) => {
        setDateRange([ranges.selection]);
    };

    const handleApply = () => {
        if (onChange) {
            onChange({
                startDate: dateRange[0].startDate,
                endDate: dateRange[0].endDate,
            });
        }
        setShowCalendar(false);
    };

    return (
        <div className="w-full flex flex-col  items-start lg:gap-2 gap-3" ref={wrapperRef}>
            {title && <p className="font-bold lg:text-2xl text-lg font-Poppins text-color1">{title}</p>}
            {title2 && <p className="font-bold lg:text-lg text-sm font-Poppins text-color1">{title2}</p>}

            <div className="flex flex-row items-start justify-start gap-3 relative w-full max-w-full sm:max-w-md">
                <input
                    type="text"
                    className="border border-color1 px-4 py-2 rounded-md flex-1 text-center cursor-pointer shadow-sm focus:ring-2 focus:ring-color1 outline-none min-w-0"
                    value={dateRange[0].startDate ? format(dateRange[0].startDate, "dd-MM-yyyy") : "jj-mm-aaaa"}
                    readOnly
                    onClick={() => setShowCalendar(true)}
                />
                <input
                    type="text"
                    className="border border-color1 flex-1 px-4 py-2 rounded-md  text-center cursor-pointer shadow-sm focus:ring-2 focus:ring-color1 outline-none min-w-0"
                    value={dateRange[0].endDate ? format(dateRange[0].endDate, "dd-MM-yyyy") : "jj-mm-aaaa"}
                    readOnly
                    onClick={() => setShowCalendar(true)}
                />

                {showCalendar && (
                    <div
                        className={`${isMobile
                            ? "fixed inset-0 z-50 bg-white p-4 overflow-auto"
                            : "absolute top-full mt-2 left-0 z-50 bg-white shadow-lg rounded-lg p-3"
                            }`}
                    >
                        <div className="flex justify-between items-center mb-2">
                            <p className="text-sm font-medium text-gray-600">Sélectionnez une période</p>
                            <button
                                className="p-1 hover:bg-gray-200 rounded-full"
                                onClick={() => setShowCalendar(false)}
                            >
                                <X size={18} className="text-gray-500" />
                            </button>
                        </div>

                        <DateRange
                            editableDateInputs={true}
                            onChange={handleSelect}
                            moveRangeOnFirstSelection={false}
                            ranges={dateRange}
                            locale={fr}
                            rangeColors={["#1A2A6C"]}
                            className={`${isMobile ? "w-full max-w-full" : ""}`}
                        />

                        <div className="flex justify-end mt-3">
                            <button
                                className="bg-color1 text-white px-5 py-2 rounded-full shadow hover:bg-color3"
                                onClick={handleApply}
                            >
                                Recharger
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DateRangeInput;
